import React from "react";

export default function Breadcrumb({
  value,
  label,
  currentStep,
  setCurrentStep,
  disabled,
  valid
}) {
  return (
    <li>
      <a
        tabIndex="-1"
        role="button"
        rel="”nofollow”"
        autoFocus={currentStep === value ? true : false}
        className={currentStep === value ? "gc__breadcrumb_button gc__breadcrumb_active" : disabled ? "gc__breadcrumb_disabled gc__breadcrumb_button" : "gc__breadcrumb_button"}
        onClick={() => {
          if (!disabled) {
            setCurrentStep(value);
          }
        }}
      >
        {label}
      </a>

    </li>
  );
}
